// react
// dependencies
import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { GenerateProcess } from "redux-process";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import DownloadButton from "../../../../components.smart/DownloadButton";
// components
import Icon from "../../../../components/Icon";
import Checkbox from "../../../../components/Inputs/Checkbox";
import TextInput from "../../../../components/Inputs/TextInput";

// actions
import { StateChange } from "../../../../actions/page.actions";

// utils
import { appendCurrentLocationAsFrom } from "../../../../utils/changeFieldsBreadcrumbs";

// constants
import Config from "../../Config";

// props
const propTypes = {
	showGroupSelector: PropTypes.bool.isRequired,
	showAddGroupButton: PropTypes.bool.isRequired,
	showlimitSelected: PropTypes.bool.isRequired,
	limitSelected: PropTypes.bool.isRequired,
	showDownloadDirectoryLink: PropTypes.bool.isRequired,
	showChangeColumnLink: PropTypes.bool.isRequired,
	onSearch: PropTypes.func.isRequired,
	changeState: PropTypes.func.isRequired,
	addGroupToSelection: PropTypes.func.isRequired,
	downloadCsv: PropTypes.func.isRequired,
	searchInput: PropTypes.string.isRequired,
	placeholder: PropTypes.string.isRequired,
};

class SearchContainer extends React.Component {
	constructor(props) {
		super(props);

		this.handleSearch = debounce(this.handleSearch.bind(this), Config.queryWaitTime);
	}

	state = {
		jobID: null,
	};

	showGroupCurtain = () => {
		this.props.changeState("showGroupCurtain", true);
	};

	addGroupToSelection = () => {
		this.props.addGroupToSelection();
	};

	handleViewSwitch = (nextState) => {
		this.props.onSearch({
			limitSelected: nextState,
			query: this.props.searchInput,
		});
	};

	handleChange = (value) => {
		this.props.changeState("searchInput", value);
		this.handleSearch(value);
	};

	handleSearch(value) {
		this.props.onSearch({ query: value });
	}

	handleDownloadCsv = async () => {
		const res = await this.props.downloadCsv();
		const jobID = res.response.get("jobID");

		this.setState({ jobID });
	};

	handleDownloadFinished = () => {
		this.setState({ jobID: null });
	};

	render() {
		const {
			placeholder,
			searchInput,
			limitSelected,
			showlimitSelected,
			showGroupSelector,
			showAddGroupButton,
			showChangeColumnLink,
			showDownloadDirectoryLink,
		} = this.props;

		const { jobID } = this.state;

		return (
			<section className="search-container">
				<div data-testid="search_container" style={{}} className="search-input-container">
					<div style={{ width: 350 }}>
						<TextInput
							name="directory-search"
							value={searchInput}
							onChange={this.handleChange}
							placeholder={placeholder}
						/>
					</div>

					{showAddGroupButton ? (
						<div
							title="Add Group"
							onClick={this.addGroupToSelection}
							className="select-group-button"
							style={{ left: 360 }}
						>
							<div
								style={{
									position: "absolute",
									top: 6,
									left: 6,
								}}
							>
								<FontAwesomeIcon icon={["fas", "smile-plus"]} />
							</div>
						</div>
					) : null}

					{showGroupSelector ? (
						<div
							onClick={this.showGroupCurtain}
							title="Add Group"
							className="select-group-button"
							style={{ left: 360 }}
						>
							<div
								style={{
									position: "absolute",
									top: 6,
									left: 6,
								}}
							>
								<Icon type="material" name="group" size={18} />
							</div>
						</div>
					) : (
						""
					)}

					{showlimitSelected ? (
						<div style={{}} className="switch-to-selected">
							<div className="switch-label">Show only selected employees</div>
							<div className="switch-box">
								<Checkbox onChange={this.handleViewSwitch} value={limitSelected} />
							</div>
						</div>
					) : (
						""
					)}
				</div>

				{showDownloadDirectoryLink ? (
					<div key="download-button" className="download-container">
						<DownloadButton
							jobID={jobID}
							autoDownload={true}
							isHollow={true}
							style={{ height: "32px" }}
							onClick={this.handleDownloadCsv}
							onDownload={this.handleDownloadFinished}
							testid="download-csv"
						>
							Download CSV
						</DownloadButton>
					</div>
				) : null}

				{showChangeColumnLink ? (
					<div className="change-container" style={{ top: (32 - 20) * 0.5 }}>
						<a href={appendCurrentLocationAsFrom("/administration/change-fields/")}>Change Columns</a>
					</div>
				) : (
					""
				)}
			</section>
		);
	}
}

SearchContainer.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
	searchInput: state.page.getIn([ownProps.storeName, "searchInput"], ""),
	limitSelected: state.page.getIn([ownProps.storeName, "limitSelected"], false),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	changeState: (keyPath, value) => dispatch(StateChange(ownProps.storeName, keyPath, value)),
	downloadCsv: () => dispatch(GenerateProcess("GenerateEmployeeCSV", { directoryFields: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer);
